import { api as wiredApi } from './index';

/**
 * The vehicle types InGo carries deliveries on, as the office keeps them
 * (Rio, 4 Oct 2026: "not limited to the three kinds we have"): `GET
 * public/vehicles`, the active ones in the office's order, no sign-in needed
 * (a rider registering chooses one). Each is `{ key, label, drawing,
 * serviceType }`: chosen by its key, quoted and booked by its service type,
 * drawn by its drawing (`components/maps/vehicleSprites.js`). Asked once a
 * session; a failed ask is asked again next time.
 */
export function createVehicles({ api }) {
  let answer = null;

  return {
    /** @returns {Promise<{ key: string, label: string, drawing: string, serviceType: string }[]>} */
    list() {
      answer ??= api
        .get('/public/vehicles')
        .then(({ data }) => {
          // `VehicleController::publicIndex` answers `{ vehicles: [...] }`: every list in InGo's
          // API sits under a named key. A 200 without one is a fault, said as one, never "no
          // vehicles" (the app read `data` as the list once, and offered nothing; 4 Oct 2026).
          if (!Array.isArray(data?.vehicles)) throw new Error('public/vehicles answered without a vehicle list.');

          return data.vehicles
            .filter((v) => typeof v?.key === 'string' && v.key !== '' && typeof v?.service_type === 'string')
            .map((v) => ({ key: v.key, label: String(v.label || v.key), drawing: String(v.drawing || ''), serviceType: v.service_type }));
        })
        // Any failure, the network's or the answer's, is forgotten: the next screen asks again.
        .catch((error) => {
          answer = null;
          throw error;
        });

      return answer;
    },

    /** Tests only: forget the answer, so the next `list()` asks again. */
    forgetForTests() {
      answer = null;
    },
  };
}

export const vehicles = createVehicles({ api: wiredApi });
